/** FastAPI/axios 오류를 화면에 표시할 문자열로 변환 */
export function formatApiErrorMessage(error: unknown, fallback: string): string {
  const response = (error as { response?: { status?: number; data?: unknown } })?.response;
  const data = response?.data;
  const status = response?.status;

  const mapGenericNotFound = (raw: string): string => {
    const t = raw.trim().toLowerCase();
    if (t === 'not found' || t === 'not found.') {
      if (status === 404) {
        return (
          '요청한 API를 찾기 불가. 백엔드가 최신인지 확인하고 재시작한 뒤, ' +
          'SMS API 경로(/api/events/actions/safety-sms)가 등록되었는지 확인.'
        );
      }
      return '요청을 처리 불가. 알리고·웹훅 URL 및 시스템 관리 → 현장 안전 SMS 설정을 확인.';
    }
    return raw;
  };

  if (!data) {
    if (status === 404) {
      return mapGenericNotFound('Not Found');
    }
    return (error as Error)?.message || fallback;
  }
  if (typeof data === 'string') {
    return mapGenericNotFound(data);
  }
  if (typeof data === 'object' && data !== null) {
    const detail = (data as { detail?: unknown }).detail;
    if (typeof detail === 'string') {
      return mapGenericNotFound(detail);
    }
    if (Array.isArray(detail)) {
      return detail
        .map((item) => {
          if (typeof item === 'string') return item;
          if (item && typeof item === 'object' && 'msg' in item) {
            const loc = Array.isArray((item as { loc?: unknown }).loc)
              ? (item as { loc: unknown[] }).loc.join('.')
              : '';
            return loc
              ? `${loc}: ${String((item as { msg: unknown }).msg)}`
              : String((item as { msg: unknown }).msg);
          }
          return JSON.stringify(item);
        })
        .join(' / ');
    }
    const message = (data as { message?: unknown }).message;
    if (typeof message === 'string') {
      return message;
    }
  }
  return fallback;
}
